export default __webpack_public_path__ + "static/media/step1img.ae7f13ca.svg";